import { stringifyQs } from "@saleor/utils/urls";

import {
  ActiveTab,
  BulkAction,
  Dialog,
  Pagination,
  SingleAction
} from "../types";

export enum ProductActivationSettingDetailsPageTab {
  voucher = "voucher"
}
const productActivationSettingSection = "/productActivationSetting/";
export const productActivationSettingPath = productActivationSettingSection;
export type ProductActivationSettingDialog =
  | "assign-voucher"
  | "unassign-voucher";
export type ProductActivationSettingUrlQueryParams = Pagination &
  SingleAction &
  Dialog<ProductActivationSettingDialog> &
  BulkAction &
  ActiveTab<ProductActivationSettingDetailsPageTab>;

export const productActivationSettingUrl = (
  params?: ProductActivationSettingUrlQueryParams
) => productActivationSettingSection + "?" + stringifyQs(params);
